import { useMemo } from 'react'
import { useOidc } from '@/auth/OidcProvider'
import { oidcConfig } from '@/auth/config'
import { isPlatformOperatorToken } from '@/auth/platformRoleClaims'

/**
 * True when the signed-in user's token carries the platform-operator role. Recomputed whenever the
 * access token changes, so a silent renew that adds or drops the role updates the UI.
 */
export function useIsPlatformOperator(): boolean {
  const { user } = useOidc()
  const accessToken = user?.access_token
  const profile = user?.profile as Record<string, unknown> | undefined
  return useMemo(
    () => isPlatformOperatorToken(accessToken, profile, oidcConfig.client_id),
    [accessToken, profile],
  )
}
